import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background: linear-gradient(0deg, #030512 0%, #002b1b 100%);
    overflow: hidden;
    padding-top: var(--sat);
    padding-bottom: var(--sab);
`;
